<p-dialog
  header="Керівник компанії"
  [visible]="visible"
  (visibleChange)="onDismiss()"
  [modal]="true"
  [closable]="state !== 'saving'"
  [style]="{'width': '480px'}"
  (onHide)="onDismiss()">

  <div class="company-director-quick-set">

    <div *ngIf="state === 'saving'" class="company-director-quick-set__saving">
      <p-progressSpinner styleClass="company-director-quick-set__spinner" strokeWidth="6"></p-progressSpinner>
    </div>

    <div *ngIf="state === 'create-offer'" class="company-director-quick-set__offer">
      <span class="company-director-quick-set__text">
        Реєстр вказує керівника «{{ extractedDirectorName }}», якого немає серед співробітників компанії.
      </span>
      <div class="company-director-quick-set__actions">
        <p-button label="Додати як керівника" icon="pi pi-user-plus" styleClass="p-button-success p-button-sm" (onClick)="onCreate()"></p-button>
        <p-button label="Пропустити" styleClass="p-button-text p-button-sm" (onClick)="onDismiss()"></p-button>
      </div>
    </div>

    <div *ngIf="state === 'update-offer'" class="company-director-quick-set__offer">
      <span class="company-director-quick-set__text">
        Реєстр вказує керівника «{{ extractedDirectorName }}», що відрізняється від поточного
        («{{ matchedDirector?.PERSONLNAME }} {{ matchedDirector?.PERSONFNAME }} {{ matchedDirector?.PERSONMNAME }}»).
      </span>
      <div class="company-director-quick-set__actions">
        <p-button label="Оновити дані керівника" icon="pi pi-user-edit" styleClass="p-button-warning p-button-sm" (onClick)="onUpdate()"></p-button>
        <p-button label="Пропустити" styleClass="p-button-text p-button-sm" (onClick)="onDismiss()"></p-button>
      </div>
    </div>

    <div *ngIf="state === 'confirmed'" class="company-director-quick-set__confirmed">
      <i class="pi pi-check-circle"></i>
      Керівник підтверджений: {{ matchedDirector?.PERSONLNAME }} {{ matchedDirector?.PERSONFNAME }} {{ matchedDirector?.PERSONMNAME }}
    </div>

    <div *ngIf="state === 'picker'" class="company-director-quick-set__picker">
      <span class="company-director-quick-set__text">
        Реєстр вказує керівника «{{ extractedDirectorName }}» — не вдалося однозначно визначити, кому з наявних співробітників це відповідає. Оберіть вручну:
      </span>

      <div class="company-director-quick-set__picker-field">
        <label for="directorPickerDd" class="do-not-wrap-text">Співробітник</label>
        <p-dropdown
          id="directorPickerDd"
          [options]="pickerOptions"
          optionLabel="label"
          [(ngModel)]="selectedPickerOption"
          [filter]="true"
          filterBy="label"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="company-director-quick-set__picker-names">
        <div class="company-director-quick-set__picker-field">
          <label for="directorPickerLName" class="do-not-wrap-text">Прізвище</label>
          <input id="directorPickerLName" type="text" pInputText [(ngModel)]="pickerLName" />
        </div>
        <div class="company-director-quick-set__picker-field">
          <label for="directorPickerFName" class="do-not-wrap-text">Ім'я</label>
          <input id="directorPickerFName" type="text" pInputText [(ngModel)]="pickerFName" />
        </div>
        <div class="company-director-quick-set__picker-field">
          <label for="directorPickerMName" class="do-not-wrap-text">По батькові</label>
          <input id="directorPickerMName" type="text" pInputText [(ngModel)]="pickerMName" />
        </div>
      </div>

      <div class="company-director-quick-set__actions">
        <p-button label="Підтвердити" icon="pi pi-check" styleClass="p-button-success p-button-sm" (onClick)="onPickerConfirm()"></p-button>
        <p-button label="Пропустити" styleClass="p-button-text p-button-sm" (onClick)="onDismiss()"></p-button>
      </div>
    </div>

  </div>

</p-dialog>
